﻿import React from 'react';
import {
  MessageContainer,
  MessageGridItem,
  MessageImage,
  MessageImageContainer,
  MessageText
} from "@securspace/securspace-ui-kit";

type PersonAndBoxMessageProps = {
  visible?: boolean;
}

/**
 * Simple component that displays a person in a box with some text
 * @constructor
 */
const PersonAndBoxMessage = ({
  visible = true
}: PersonAndBoxMessageProps) => {
  return visible && <MessageContainer>
    <MessageGridItem>
      <MessageImageContainer>
        <MessageImage src={'/app-images/person-and-box.svg'} />
      </MessageImageContainer>
      <MessageText>
        No matching records found.
      </MessageText>
    </MessageGridItem>
  </MessageContainer>
}

export { PersonAndBoxMessage };
